import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LangContext, translations } from "./i18n";
import { FloatingWA, Footer, Header } from "./components/Shared";
import HomePage from "./pages/HomePage";
import KumbhPage from "./pages/KumbhPage";
import DestinationPage from "./pages/DestinationPage";
import "@/App.css";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -72 });
        else document.querySelector(hash)?.scrollIntoView();
      }, 350);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    try {
      const saved = localStorage.getItem("teerthaatan-language");
      if (saved === "hi" || saved === "en") setLang(saved);
    } catch (e) { /* storage may be blocked */ }
  }, []);

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  const changeLang = (next) => {
    setLang(next);
    try { localStorage.setItem("teerthaatan-language", next); } catch (e) {}
  };

  return (
    <LangContext.Provider value={{ lang, copy: translations[lang], changeLang }}>
      <BrowserRouter>
        <div className="site-shell">
          <div className="grain" aria-hidden="true" />
          <ScrollManager />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/kumbh" element={<KumbhPage />} />
            <Route path="/kumbh/:city" element={<DestinationPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Footer />
          <FloatingWA />
        </div>
      </BrowserRouter>
    </LangContext.Provider>
  );
}
